"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createNarrowHeader = function (ref, setNarrow) {
    var scrollHandler = function () {
        if (window.scrollY > 50) {
            if (ref.current)
                ref.current.style.height = '60px';
            setNarrow(true);
        }
        else {
            //@ts-ignore
            if (ref.current)
                ref.current.style.height = null;
            setNarrow(false);
        }
    };
    var subscribeNarrowHeader = function () {
        document.addEventListener('scroll', scrollHandler, true);
    };
    var removeNarrowHeader = function () {
        document.removeEventListener('scroll', scrollHandler);
    };
    return { subscribeNarrowHeader: subscribeNarrowHeader, removeNarrowHeader: removeNarrowHeader };
};
exports.default = createNarrowHeader;
